import { createApp } from "vue";
import * as Sentry from "@sentry/vue";
import VueMatomo from 'vue-matomo';

import envOptions from "./helpers/Env.js";

// Load the svg icons as a spritesheet
import "virtual:svg-icons-register";

// Load CSS
import "./scss/main.scss"; // main global CSS file

// The router manages access to every part of the software.
// It makes sure that the user lands in the correct views for their use case.
// eslint-disable-next-line no-restricted-imports
import router from "./router/router.js";

// The i18n module handles all text and translations.
import i18n from "./i18n";

import connectElectron from "./electron-glue.js";
import globalErrorHandler from "@core/errors/ErrorHandler.js";

// Plugins
import Toast, { POSITION as TOAST_POSITION } from "vue-toastification";

// The store handles all data constructs.
import { pinia } from "./pinia";
import { useModelStore } from "@editor/items/model/model.store";

import App from "./app/App.vue";

// ERROR HANDLING
globalErrorHandler.register(window);

const app = createApp(App);

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  release: envOptions.version
});

// Register all plugins
if (envOptions.matomoSiteId) {
  app.use(VueMatomo, {
    router: router,
    host: envOptions.matomoUrl,
    siteId: envOptions.matomoSiteId,
    trackInitialView: true,
    disableCookies: true
  });
}
app.use(pinia);
app.use(i18n);
app.use(router);
app.use(Toast, {
  position: TOAST_POSITION.TOP_RIGHT
});

// init store
const modelStore = useModelStore();
modelStore.$reset();

app.mount("#app");

// Add listeners to electron commands, handling any communication
// between the vue software and electron.
connectElectron(app);

export default app;
